import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as actions from 'app/core/store/admin/users/users.actions';
import { fadeInAnimation } from '../../../../animations';
import * as fromRoot from '../../../../core/store';
import { AdminDefinitions } from '../../../../core/store/admin/admin-definitions/admin-definitions.interface';
import { EpsUserInviteAction, EpsUserUpdateAction } from '../../../../core/store/admin/users/users.actions';
import { EditUser, EpsUser } from '../../../../core/store/admin/users/users.interface';
import { BaseContainer } from '../../../base/BaseContainer';
import { ScrollService } from '../../../../core/services/scroll.service';
import { goAction } from '../../../../core/store/router/router.actions';
import { map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'admin-customer-eps-edit',
  templateUrl: './eps-user-edit.container.html',
  styleUrls: ['./eps-user-edit.container.scss'],
  animations: [fadeInAnimation],
})
export class EpsUserEditContainer extends BaseContainer implements OnInit {
  readonly = false; // Edit can also be used as VIEW (just like clientUserEditContainer).  A bit awkward, but less code. If you want it differently, I'll adapt it
  editUser: EditUser;
  adminDefinitions: AdminDefinitions;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private scrollService: ScrollService
  ) {
    super();
    route.data.pipe(takeWhile(() => !this.destroyed)).subscribe(data => (this.readonly = !!data.readonly));
    this.store
      .select('admin')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((admin: any) => admin.edit)
      )
      .subscribe(editUser => (this.editUser = editUser));
    this.store
      .select('admin')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((admin: any) => admin.adminDefinitions)
      )
      .subscribe(adminDefinitions => {
        return (this.adminDefinitions = adminDefinitions);
      });
  }

  ngOnInit(): void {
    this.scrollService.scrollToElement('top');
  }

  cancelClicked() {
    this.store.dispatch(goAction({ path: '/admin/epsUsers' }));
  }

  updateUser(epsUser: EpsUser) {

    this.store.dispatch(new EpsUserUpdateAction(epsUser));
  }

  inviteUser(epsUser: EpsUser) {
    this.store.dispatch(new EpsUserInviteAction(epsUser));
  }

  createUser(epsUser: EpsUser) {
    // Only implemented in eps-user-create.container
  }

  reInvite(userId: string) {
    this.store.dispatch(new actions.UserReInviteAction({ userId, overviewUrl: '/admin/epsUsers' }));
  }

  resetPassword(userId: string) {
    this.store.dispatch(new actions.UserResetPasswordAction({ userId, overviewUrl: '/admin/epsUsers' }));
  }
}
